import { render, staticRenderFns } from "./NavigationSidebar.vue?vue&type=template&id=0249d12d&scoped=true&"
import script from "./NavigationSidebar.vue?vue&type=script&lang=ts&"
export * from "./NavigationSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationSidebar.vue?vue&type=style&index=0&id=0249d12d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0249d12d",
  null
  
)

export default component.exports